<div class="crosslinkingBox">
  <div class="headingPage">
    <h2 class="">Select Suggested Keywords</h2>
  </div>
  <div class="searchBlock">

    <div class="searchSection">   <i class="icon-search"></i>
      <div class="searchtxt">
        <input [formControl]='searchQuery' class="search-components textBox" type="text"
        placeholder="Search topic pages"
        [(ngModel)]="topicName" autofocus/>
      </div>
    </div>

  </div>
  <div class="keywordList">
    <div class="scrollY">
  <ul>
    <ng-container *ngIf="listArray.length > 0">
      <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
        <li (click)="getPageurl(item)">
          <div class="title"> {{item.name}} </div>
          <div class="url"> {{item.url}} </div>
        </li>
      </ng-container>
    </ng-container>

  </ul>
</div>
</div>
</div>



